import React, { useEffect, useState } from "react";
import Helper from "../helper";
import AppSettings from "../settings";
import "../css/news.css";
import MediaPlayer from "./MediaPlayer";
import { useParams } from "react-router-dom";


const News = () => {
  const {idNota} = useParams();

  useEffect(()=>{
    console.log(idNota)
  })

  return (
    <div>
      <NewsPage newsId={idNota} changePageHandler={(ev) => this.handleChangePage(ev)} />
    </div>
  )
}

export default News


export class NewsPage extends React.Component {
  

  constructor(props) {
    super(props);
    this.state = {
      newsData: {},
    };
  }
  

  render() {
    return (
      <section className='u-clearfix u-grey-10 u-section-1'>
        <div className='u-clearfix u-sheet u-sheet-1'>
          <NewsPageDetail newsData={this.state.newsData} />
        </div>
      </section>
    );
  }

  componentDidMount() {
    this.getNewsDetail(this.props.newsId);
  }

  getNewsDetail(newsId) {
    const apiUrl = AppSettings.apiUrlNewsDetail + newsId;
    console.log(newsId)
    fetch(apiUrl).then(
      (res) => {
        res.json().then((jsres) => {
          Helper.checkItemsApiResponse(jsres);
          let res = jsres.data[0];
          console.log(res.media_url);
          this.setState({
            newsData: res,
          });
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }
}

class NewsPageDetail extends React.Component {
  formatText = (text) => {
    // Retorna una cadena vacía si el texto no es definido o no es una cadena de texto
    if (!text || typeof text !== "string") {
      return "";
    }
    // Aca dividimos el texto en oraciones usando puntos como delimitadores y si hay un espacio despues del punto
    const sentences = text.split(". ");

    // Filtra las lineas vacías y agrega un punto al final de cada oración si no lo tiene
    const formattedSentences = sentences
      .filter((sentence) => sentence.trim() !== "")
      .map((sentence) => {
        const trimmedSentence = sentence.trim();
        return (
          trimmedSentence.charAt(0).toUpperCase() +
          trimmedSentence.slice(1).trim() +
          "."
        );
      });

    // Aca unimos las oraciones formateadas en un nuevo texto
    // y le colocamos un salto de linea cuando consiga un punto y aparte.
    const formattedText = formattedSentences
      .map((sentence) => `${sentence}<br><br>`)
      .join("");

    return formattedText;
  };
  render() {
    // Capturamos lo que traiga la noticia en cuanto a Video/Audio y le aplicamos a la noticia
    const mediaPlayerUrls = this.props.newsData.media_url;

    // Capturamos lo que trae el string de la nota para procesarlo y darle formato gramatical
    const textoPlano = this.props.newsData.nota;
    const formattedText = this.formatText(textoPlano);

    // Capturamos la imagen para validar y mostrar la imagen dentro del detalle de la noticia
    const imagenPrincipal = this.props.newsData.imagen_principal;

    return (
      <div>
        {/* Fecha y Fuente de la Noticia */}
        <div className="news__top">
          <p className='u-custom-font u-heading-font u-text u-text-grey-80 u-text-1 news__fecha'>
            {new Date(this.props.newsData.fecha).toLocaleDateString(
              AppSettings.defaultLocale
            )}
            &nbsp;{this.props.newsData.fuente}
          </p>
          <a
            className="news__volver"
            href='/'
          >
            Volver
          </a>
        </div>

        {/* Titulo de la Noticia */}
        <h3 className='u-text u-text-2'>{this.props.newsData.titulo}</h3>
        <br></br>

        {/* Imagen de la Noticia, se valida si existe la muestra sino no la muestra*/}
        {imagenPrincipal && (
          <img
            alt=''
            className='estiloImagen'
            src={
              imagenPrincipal &&
              Helper.getImageUrl(this.props.newsData.imagen_principal, true)
            }
          ></img>
        )}

        {/* Audio o Video de la Noticia, se valida si existe la muestra sino no la muestra  */}
        {mediaPlayerUrls && <MediaPlayer mediaPlayerUrl={mediaPlayerUrls} />}

        {/* Nota de la Noticia, se le aplica formato y justificacion*/}
        {
          <p
            className='news-container u-align-left u-custom-font u-heading-font u-large-text u-text u-text-variant u-text-3'
            style={{ textAlign: "justify", paddingBottom: "50px" }}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          ></p>
        }
      </div>
    );
  }
}
